<template>
  <div>
    <b-modal
      hide-footer
      no-close-on-esc
      :title-html="
        `<div class='d-flex align-items-center'><span class='lock'></span>&nbsp;<span>Authentication Required!</span></div>`
      "
      :ref="refId"
      :id="refId"
      header-class="managerAuthPop__header_class"
      modal-class="managerAuthPop__modal_class"
      title-class="managerAuthPop__title_class"
      centered
      no-fade
      no-stacking
      no-enforce-focus
      no-close-on-backdrop
      @hidden="cancelAuth()"
    >
      <div class="row mx-0">
        <div class="col-12">
          <div class="col-lg-10 mx-auto align-self-center">
            <div class>
              <div class="">
                <div class="input-material">
                  <input
                    type="text"
                    v-model="username"
                    v-on:keyup.enter="authenticateLogin"
                    name="username"
                    id="username"
                    v-validate="'required'"
                    placeholder="username"
                    @click="onClickInputHandler('username')"
                  />
                  <label>Username</label>
                </div>
                <div v-if="showKeyBoard">
                  <VkeyboardFloat
                    :ID="'username'"
                    :onClickFun="
                      () => {
                        showUsernameVKeyboard = !showUsernameVKeyboard;
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'username'"
                    :showOrHide="showUsernameVKeyboard"
                    :initialValue="username"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="authenticateLogin()"
                    @changeKeyboardInput="username = $event"
                    @onClickClose="
                      () => {
                        showUsernameVKeyboard = false;
                      }
                    "
                  />
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('username')">{{
                    errors.first("username")
                  }}</span>
                </p>
              </div>
              <div class="input-material">
                <input
                  type="password"
                  v-model="password"
                  v-on:keyup.enter="authenticateLogin"
                  name="password"
                  id="password"
                  v-validate="'required'"
                  placeholder="password"
                  @click="onClickInputHandler('password')"
                />
                <label>Password</label>
              </div>
              <div v-if="showKeyBoard">
                <VkeyboardFloat
                  :ID="'password'"
                  :onClickFun="
                    () => {
                      showPassVKeyboard = !showPassVKeyboard;
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'password'"
                  :initialValue="password"
                  :showOrHide="showPassVKeyboard"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="authenticateLogin()"
                  @changeKeyboardInput="password = $event"
                  @onClickClose="
                    () => {
                      showPassVKeyboard = false;
                    }
                  "
                />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('password')">{{
                  errors.first("password")
                }}</span>
              </p>
              <div class="d-flex mt-1 justify-content-center">
                <button
                  @click.prevent.stop="$bvModal.hide(refId)"
                  class="btn btn-sm btn-outline-primary mr-5"
                >
                  Cancel
                </button>
                <button
                  @click.prevent.stop="authenticateLogin"
                  class="btn btn-sm btn-primary"
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService.js";
  import UserService from "@/services/UserService.js";
  import PosService from "@/services/PosService.js";
  import { mapState, mapGetters, mapActions } from "vuex";
  import { BASEURL } from "@/config/index.js";
  import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
  import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

  export default {
    props: {
      showKeyBoard: {
        type: Boolean,
        default: true,
      },
      refId: {
        type: String,
        default: "authManagerLoginPopup",
      },
      moduleName: {
        type: String,
        default: "default",
      },
      onCheckAuth: {
        type: Function,
        default: () => console.log("default function"),
      },
      additionalRoleIds: {
        type: String,
        default: "",
      },
    },
    components: {
      Vkeyboard,
      VkeyboardFloat,
    },
    data() {
      return {
        username: "",
        password: "",
        showVKeyboard: false,
        showPassVKeyboard: false,
        showUsernameVKeyboard: false,
        submitted: false,
      };
    },
    computed: {
      ...mapGetters([]),
    },
    mounted() {},
    methods: {
      ...mapActions([]),
      onClickInputHandler(event) {
        if (this.showUsernameVKeyboard && event == "password") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = true;
        } else if (this.showUsernameVKeyboard && event == "username") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = false;
        } else if (this.showPassVKeyboard && event == "username") {
          this.showUsernameVKeyboard = true;
          this.showPassVKeyboard = false;
        } else if (this.showPassVKeyboard && event == "password") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = false;
        }
      },
      cancelAuth() {
        this.$emit("AuthValid", false);
        this.onCheckAuth({
          name: this.moduleName,
          valid: false,
          user_id: null,
          id: 48,
        });
      },
      authenticateLogin() {
        let self = this;
        console.log("authenticateLogin");
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            let payload = {
              username: this.username,
              password: this.password,
              roleIds: this.additionalRoleIds || "",
            };

            PosService.CheckCinemaManagerAuth(payload)
              .then((response) => {
                const { data } = response;
                if (data.status) {
                  this.$emit("ManagerDetails", data.user_id);
                  this.username = "";
                  this.password = "";
                  this.$emit("AuthValid", true);
                  this.onCheckAuth({
                    name: this.moduleName,
                    valid: true,
                    user_id: data.user_id,
                    id: 1,
                  });
                  this.$refs[this.refId].hide();
                } else {
                  this.$emit("ManagerDetails", null);
                  this.$emit("AuthValid", false);
                  this.onCheckAuth({
                    name: this.moduleName,
                    valid: false,
                    user_id: null,
                    id: 2,
                  });
                  this.$toasted.show(
                    data.message ||
                      "Sorry! Something went wrong. kindly contact your administrator"
                  );
                }
              })
              .catch((err) => {
                console.log("ERROR:", err);
                this.$emit("AuthValid", false);
                this.onCheckAuth({
                  name: this.moduleName,
                  valid: false,
                  user_id: null,
                  id: 3,
                  err,
                });
                console.log("Error:", err);
              })
              .finally(() => {
                loader.hide();
              });
          }
        });
      },
    },
  };
</script>
<style>
  .disbled-section {
    cursor: not-allowed;
    opacity: 0.4;
  }

  .managerAuthPop__title_class {
    font-size: 12px !important;
  }

  .managerAuthPop__header_class {
    padding: 0.4rem 1rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/AuthManagerLoginPopup.vue